import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  endDemoSession,
  getDemoSession,
  startDemoSession,
} from "../../firebase/DemoModeService";

const DemoModeContext = createContext(null);

export const DemoModeProvider = ({ children }) => {
  const [session, setSession] = useState(getDemoSession());

  useEffect(() => {
    const refresh = () => setSession(getDemoSession());
    window.addEventListener("storage", refresh);
    window.addEventListener("clearhealth-demo-session-change", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("clearhealth-demo-session-change", refresh);
    };
  }, []);

  const value = useMemo(() => ({
    session,
    isDemoMode: session?.active === true,
    startDemo: (options) => setSession(startDemoSession(options)),
    exitDemo: () => {
      endDemoSession();
      setSession(getDemoSession());
    },
  }), [session]);

  return (
    <DemoModeContext.Provider value={value}>
      {children}
    </DemoModeContext.Provider>
  );
};

export const useDemoMode = () => useContext(DemoModeContext);

